import { HelpersService, NavService, ThemeStore } from '@aeins/core';
import { AnonymousContractAcknowledgmentClient, AnonymousVviClient, CorporateIdentityResponse } from '@aeins/sharedfrontendapi';
import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn } from '@angular/router';
import { LocalAppStore } from 'app/stores/local-app.store';
import { catchError, firstValueFrom, of } from 'rxjs';

export const RoutingHandler: ResolveFn<Promise<string | null>> = async (route: ActivatedRouteSnapshot) => {
    const helpers = inject(HelpersService);

    if (route.url.length && route.url.toString() !== '/') {
        const routeAlias = (await (await fetch('./assets/config/route-aliases.json')).json())?.[route.url[0].path];
        if (routeAlias) {
            let params = JSON.stringify(routeAlias.params);
            for (let i = 1; i < route.url.length; i++) {
                params = params.replace(`{${i - 1}}`, route.url[i].path);
            }
            const resolvedRoute = `/${routeAlias.page}/${helpers.jsonToBase64(JSON.parse(params))}`;
            return resolvedRoute;
        }
    }

    return null;
};

let isCiSet = false;
export const AdditionalCheckHandler: ResolveFn<Promise<boolean>> = async (route: ActivatedRouteSnapshot) => {
    if (!isCiSet) {
        const anonymousVviClient = inject(AnonymousVviClient);
        const anonymousContractAcknowledgmentClient = inject(AnonymousContractAcknowledgmentClient);
        const navService = inject(NavService);
        const themeStore = inject(ThemeStore);
        const localAppStore = inject(LocalAppStore);

        const vviGuid = navService.getRouteMeta(`${route.params.id}/${route.params.params}`)?.params.vviGuid;
        const contractGuid = navService.getRouteMeta(`${route.params.id}/${route.params.params}`)?.params.contractGuid;
        if (vviGuid || contractGuid) {
            let ci: CorporateIdentityResponse | null;
            if (vviGuid) {
                ci = await firstValueFrom(anonymousVviClient.getCorporateIdentityForVvi(vviGuid).pipe(catchError(() => of(null))));
            } else {
                ci = await firstValueFrom(anonymousContractAcknowledgmentClient.getCorporateIdentityForContract(contractGuid).pipe(catchError(() => of(null))));
            }
            themeStore.setCI(ci?.cssRuleResponse?.cssVariableValues ?? {}, ci?.logoLightModeAsBase64 ?? '', ci?.logoDarkModeAsBase64 ?? '');
            localAppStore.setCi(ci);
            isCiSet = true;
        }
    }

    return true;
};
